export 
const DATA = {
    restra: "Kamuska",
    timings: [
        { open: "00:00", close: "22:00" },  
        { open: "22:00", close: "23:59" }   
    ],
    items: [

        /* 🌾 BIRYANI */
        {
            _id: "b1",
            title: "Soyabean Biryani (Jeera)", //500g
            category: "Biryani",
            price: 85,
            disabled: false,
            remark: "",
            type: "Veg",
            image: "image/biryani1.png"
        },
        {
            _id: "b2",
            title: "Soyabean Biryani (Onion)",
            category: "Biryani",
            price: 85,
            disabled: false,
            remark: "",
            type: "Veg",
            image: "image/biryani1.png"
        },

        /* 🍚 PULAO */
        {
            _id: "p1",
            title: "Soyabean Pulao (Spicy)", //450g
            category: "Pulao",
            price: 75,
            disabled: false,
            remark: "",
            type: "Veg",
            image: "image/pulao1.png"
        },
        {
            _id: "p2",
            title: "Soyabean Pulao (Less Spicy)",
            category: "Pulao",
            price: 75,
            disabled: true,
            remark: "Unavailable",
            type: "Veg",
            image: "image/pulao1.png"
        },

        /* 🥤 WATER & DRINKS */
        {
            _id: "w1",
            title: "Bisleri Water (250ml)",
            category: "Water",
            price: 6,
            disabled: false,
            remark: "",
            type: "Veg",
            image: "image/water-200.png"
        },
        {
            _id: "w2",
            title: "Bisleri Water (200ml)",
            category: "Water",
            price: 5,
            disabled: false,
            remark: "",
            type: "Veg",
            image: "image/water-250.jpg"
        },

        /* 🎁 COMBO */
        {
            _id: "c1",
            title: "Soyabean Biryani + Water",
            category: "Combo",
            price: 90,
            disabled: false,
            remark: "",
            type: "Veg",
            image: "image/biryani1.png"
        },
        {
            _id: "c2",
            title: "Soyabean (Biryani + Pulao)",
            category: "Combo",
            price: 145,
            disabled: false,
            remark: "",
            type: "Veg",
            image: "image/biryani1.png"
        }
    ]
};